;(function () {
  'use strict'

  function qs(root, sel) {
    return root.querySelector(sel)
  }

  function qsa(root, sel) {
    return Array.from(root.querySelectorAll(sel))
  }

  function initTagReveal(section) {
    const inner = qs(section, '.nail-trending-sections__tags-inner')
    if (!inner || !inner.classList.contains('nail-trending-sections__tags-inner--reveal-pending')) return
    if (inner.dataset.nailTrendingSectionsTagIo === '1') return

    const tags = qsa(inner, '.nail-trending-sections__tag')
    if (!tags.length) {
      inner.classList.remove('nail-trending-sections__tags-inner--reveal-pending')
      return
    }

    inner.dataset.nailTrendingSectionsTagIo = '1'

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      inner.classList.remove('nail-trending-sections__tags-inner--reveal-pending')
      inner.classList.remove('nail-trending-sections__tags-inner--revealed')
      return
    }

    function sortByVisualLeft() {
      return tags.slice().sort(function (a, b) {
        return a.getBoundingClientRect().left - b.getBoundingClientRect().left
      })
    }

    function stripRevealArtifacts() {
      inner.classList.remove('nail-trending-sections__tags-inner--reveal-pending')
      inner.classList.remove('nail-trending-sections__tags-inner--revealed')
      tags.forEach(function (el) {
        el.style.removeProperty('--tag-reveal-i')
      })
    }

    function reveal() {
      if (inner.classList.contains('nail-trending-sections__tags-inner--revealed')) return
      const ordered = sortByVisualLeft()
      ordered.forEach(function (el, i) {
        el.style.setProperty('--tag-reveal-i', String(i))
      })
      inner.classList.add('nail-trending-sections__tags-inner--revealed')
      var ms = 1280 + (ordered.length - 1) * 150
      window.setTimeout(stripRevealArtifacts, ms)
    }

    var obs = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue
          obs.disconnect()
          requestAnimationFrame(function () {
            requestAnimationFrame(reveal)
          })
          break
        }
      },
      { root: null, rootMargin: '0px 0px -5% 0px', threshold: 0.1 }
    )

    obs.observe(inner)
  }

  function initSection(section) {
    if (section.dataset.nailTrendingSectionsJs === '1') return

    initTagReveal(section)

    const viewport = qs(section, '.nail-trending-sections__viewport')
    const track = qs(section, '.nail-trending-sections__track')
    if (!viewport || !track) {
      section.dataset.nailTrendingSectionsJs = '1'
      return
    }

    const slidesPerView = () => (window.innerWidth >= 1024 ? 3 : 1)
    const cards = qsa(track, '.nail-trending-sections__card-wrap')
    if (!cards.length) {
      section.dataset.nailTrendingSectionsJs = '1'
      return
    }

    const dotsWrap = qs(section, '[data-nail-trending-sections-pagination]')
    /** @type {HTMLButtonElement[]} */
    let dotButtons = []

    const navWrap = qs(section, '[data-nail-trending-sections-nav]')
    const prevBtn = qs(section, '.nail-trending-sections__nav--prev')
    const nextBtn = qs(section, '.nail-trending-sections__nav--next')

    let page = 0

    function pageCount() {
      const spv = slidesPerView()
      return Math.max(1, Math.ceil(cards.length / spv))
    }

    function clampPage(p) {
      const max = pageCount() - 1
      return Math.max(0, Math.min(max, p))
    }

    function setViewportWidthVar() {
      const w = viewport.getBoundingClientRect().width
      viewport.style.setProperty('--viewport-inner-w', w + 'px')
    }

    function parseGapPx(el) {
      const g = getComputedStyle(el).gap || '0px'
      const m = String(g).match(/^([\d.]+)px/)
      return m ? parseFloat(m[1]) : 0
    }

    function slideStepPx() {
      const vw = viewport.getBoundingClientRect().width
      if (window.innerWidth >= 1024) return vw
      const first = cards[0]
      if (!first) return vw
      return first.getBoundingClientRect().width + parseGapPx(track)
    }

    function applyTransform() {
      const step = slideStepPx()
      track.style.transform = 'translateX(' + -page * step + 'px)'
    }

    function ensureDots() {
      if (!dotsWrap) return
      const pc = pageCount()
      const ariaBase = dotsWrap.getAttribute('aria-label') || 'Pagination'

      if (pc <= 1) {
        dotsWrap.setAttribute('hidden', '')
        dotsWrap.innerHTML = ''
        dotButtons = []
        return
      }

      dotsWrap.removeAttribute('hidden')

      if (dotButtons.length === pc) return

      dotsWrap.innerHTML = ''
      dotButtons = []
      for (let i = 0; i < pc; i++) {
        const btn = document.createElement('button')
        btn.type = 'button'
        btn.className = 'pagination-dots__dot'
        btn.setAttribute('role', 'tab')
        btn.setAttribute('aria-label', ariaBase + ' ' + (i + 1))
        const idx = i
        btn.addEventListener('click', function () {
          goTo(idx)
        })
        dotsWrap.appendChild(btn)
        dotButtons.push(btn)
      }
    }

    function syncDots() {
      ensureDots()
      const pc = pageCount()
      if (pc <= 1) return
      dotButtons.forEach(function (btn, i) {
        const on = i === page
        btn.classList.toggle('active', on)
        btn.setAttribute('aria-selected', on ? 'true' : 'false')
      })
    }

    function syncNav() {
      if (!navWrap || !prevBtn || !nextBtn) return
      const max = pageCount() - 1
      if (max < 1) {
        navWrap.hidden = true
        return
      }
      navWrap.hidden = false
      const atStart = page <= 0
      const atEnd = page >= max
      prevBtn.classList.toggle('nail-trending-sections__nav--disabled', atStart)
      nextBtn.classList.toggle('nail-trending-sections__nav--disabled', atEnd)
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false')
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false')
    }

    function goTo(p) {
      page = clampPage(p)
      applyTransform()
      syncDots()
      syncNav()
    }

    function onResize() {
      setViewportWidthVar()
      page = clampPage(page)
      applyTransform()
      syncDots()
      syncNav()
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault()
        e.stopPropagation()
        goTo(page - 1)
      })
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault()
        e.stopPropagation()
        goTo(page + 1)
      })
    }

    let resizeT
    window.addEventListener('resize', function () {
      clearTimeout(resizeT)
      resizeT = setTimeout(onResize, 120)
    })

    let touchStartX = 0
    viewport.addEventListener(
      'touchstart',
      function (e) {
        if (!e.changedTouches[0]) return
        touchStartX = e.changedTouches[0].clientX
      },
      { passive: true }
    )

    viewport.addEventListener(
      'touchend',
      function (e) {
        if (!e.changedTouches[0]) return
        const dx = e.changedTouches[0].clientX - touchStartX
        if (Math.abs(dx) > 40) {
          goTo(page + (dx < 0 ? 1 : -1))
        }
      },
      { passive: true }
    )

    setViewportWidthVar()
    goTo(0)
    requestAnimationFrame(function () {
      setViewportWidthVar()
      applyTransform()
      syncDots()
      syncNav()
    })

    section.dataset.nailTrendingSectionsJs = '1'
  }

  function initAllNailTrendingSections(root) {
    const base = root && typeof root.querySelectorAll === 'function' ? root : document
    const seen = new Set()
    function run(node) {
      if (!node || seen.has(node)) return
      seen.add(node)
      initSection(node)
    }
    if (base.nodeType === 1 && base.hasAttribute('data-nail-trending-sections')) {
      run(base)
    }
    base.querySelectorAll('[data-nail-trending-sections]').forEach(run)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllNailTrendingSections(document)
    })
  } else {
    initAllNailTrendingSections(document)
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      const t = event.target
      if (!t || !t.querySelectorAll) return
      initAllNailTrendingSections(t)
    })
  }
})()

